import {MechanicValidator} from './MechanicValidator'
import {MechanicPirateState, MechanicShipState, PlayerColor, TileEdgeType} from '@colonist/game-states'
import {MechanicValidatorShip} from './MechanicValidatorShip'
import {ActionStatus} from '@colonist/game-base-types'
import {ArrayUtils} from '@colonist/utils'
import {MechanicValidatorPirate} from './MechanicValidatorPirate'
import {PlayerValidator} from '../core/PlayerValidator'
import {MapValidator} from '../core/map/MapValidator'

export class MechanicValidatorShipMove extends MechanicValidator {
    private readonly validatorShip: MechanicValidatorShip
    private readonly validatorPirate?: MechanicValidatorPirate

    constructor(playerValidators: PlayerValidator[], mapValidator: MapValidator, shipState: MechanicShipState, pirateState: MechanicPirateState | undefined) {
        super(playerValidators, mapValidator)

        this.validatorShip = new MechanicValidatorShip(playerValidators, mapValidator, shipState, pirateState)
        if(pirateState != undefined) this.validatorPirate = new MechanicValidatorPirate(mapValidator, pirateState)
    }

    canPlayerMoveShip(player: PlayerColor): ActionStatus {
        const playerController = this.playerValidators.get(player)
        if(playerController == undefined) return {canTakeAction: false, errorMessageIfCantTakeAction: {key: 'strings:game.errors.noPlayer'}, validHoverLocations: []}

        const movableShips = this.getMovableShipsForPlayer(player)

        const shipPlayerState = this.validatorShip.getShipPlayerState(player)
        if(shipPlayerState.hasMovedShipThisTurn) return {canTakeAction: false, errorMessageIfCantTakeAction: {key: 'strings:game.errors.canOnlyMoveOneShipPerTurn'}, validHoverLocations: movableShips}

        if(movableShips.length <= 0) return {canTakeAction: false, errorMessageIfCantTakeAction: {key: 'strings:game.errors.noOpenShips'}, validHoverLocations: movableShips}

        return {canTakeAction: true, validHoverLocations: movableShips}
    }

    getMovableShipsForPlayer(player: PlayerColor): number[] {
        const shipsThatCanBeMoved: number[] = []
        for(const tileEdge of this.mapValidator.tileState.tileEdges) {
            if(tileEdge.owner != player) continue
            if(tileEdge.type != TileEdgeType.Ship) continue
            if(this.validatorPirate?.isEdgeTouchingTileWithPirate(tileEdge)) continue

            const edgeIndex = this.mapValidator.tileState.getTileEdgeIndex(tileEdge.hexEdge)
            if(edgeIndex == undefined) continue

            const whereCouldShipBeMoved = this.validatorShip.whereCanPlayerPlaceShips(player, edgeIndex)
            if(whereCouldShipBeMoved.length == 0) continue

            if(this.mapValidator.willMovingEdgeTypeBreakClosedRoute(player, tileEdge, TileEdgeType.Ship)) continue
            if(shipsThatCanBeMoved.includes(edgeIndex)) continue

            shipsThatCanBeMoved.push(edgeIndex)
        }

        const playerController = this.playerValidators.get(player)
        if(playerController == undefined) return shipsThatCanBeMoved

        const shipPlayerState = this.validatorShip.getShipPlayerState(player)
        for(const shipPlacedThisTurn of shipPlayerState.restrictedShipMovesFrom ?? []) {
            ArrayUtils.removeElementFromArray(shipsThatCanBeMoved, shipPlacedThisTurn)
        }
        return shipsThatCanBeMoved
    }
}
